import { ErrorPage } from '@acme/features';
import { useNavigate } from 'react-router-dom';

export const Error400Page = () => {
  const navigate = useNavigate();
  return <ErrorPage statusCode={400} onAction={() => navigate('/dashboard')} />;
};

export const Error401Page = () => {
  return <ErrorPage statusCode={401} />;
};

export const Error403Page = () => {
  return <ErrorPage statusCode={403} />;
};

export const Error404Page = () => {
  return <ErrorPage statusCode={404} />;
};

export const Error500Page = () => {
  return <ErrorPage statusCode={500} />;
};
